import * as React from 'react';

import FileBoxNote16 from './FileBoxNote16';

export const fileBoxNote16 = () => <FileBoxNote16 />;

export default {
    title: 'Icon|Fill|FileBoxNote16',
    component: FileBoxNote16,
    parameters: {
        notes: "`import FileBoxNote16 from 'box-ui-elements/es/icon/fill/FileBoxNote16';`",
    },
};
